import { useEffect } from "react";
import "./InativarDesvioNegarModal.css";

export default function InativarDesvioNegarModal({ open, label, onClose, onConfirm }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose, onConfirm]);

  if (!open) return null;

  return (
    <div className="dvenim-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="dvenim-modal" role="dialog" aria-modal="true" aria-label="Inativar item">
        <header className="dvenim-header">
          <h3 className="dvenim-title">Inativar</h3>
          <button type="button" className="dvenim-close" aria-label="Fechar" onClick={onClose}>
            x
          </button>
        </header>

        <div className="dvenim-body">
          Deseja <strong>inativar</strong> "{label || "este item"}"?
        </div>

        <footer className="dvenim-footer">
          <button type="button" className="dvenim-btn dvenim-btn--ghost" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="dvenim-btn dvenim-btn--warn" onClick={onConfirm}>
            Inativar
          </button>
        </footer>
      </div>
    </div>
  );
}
